import { __awaiter } from "tslib";
import { TeleInterconsultService } from "@/servicesTs/models/teleopi/teleInterconsult";
const moduleTableHistoryTICPatient = {
    namespaced: true,
    state: {
        teleInterconsults: [],
        rut: "",
        showLoader: false,
    },
    getters: {
        getShowLoader(state) {
            return state.showLoader;
        },
        getHistoryTICPatient(state) {
            return state.teleInterconsults;
        },
    },
    mutations: {
        setLoader(state, payLoad) {
            state.showLoader = payLoad;
        },
        setDatafilter(state, payLoad) {
            state.rut = payLoad;
        },
        setHistoryTICPatient(state, teleInterconsults) {
            state.teleInterconsults = teleInterconsults;
        },
    },
    actions: {
        getHistoryTICPatient({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoader", true);
                const RESPONSE = yield TeleInterconsultService.getFindByPatientRut(state.rut);
                commit("setHistoryTICPatient", RESPONSE);
                commit("setLoader", false);
            });
        },
    },
};
export default moduleTableHistoryTICPatient;
